<div>
    <label class="heading">Planned Orders(TLMS)</label>

    <div class="col-8" style="padding-left:15px">
        <div>
            <mat-form-field class="col-4">
                <mat-label class="asterisk_input">Route Run</mat-label>
                <input matInput placeholder="(ABCD-01/ABC-01 Format)" (blur)='validateInput()' [(ngModel)]="routeRun"
                    maxlength="7">
                <mat-hint class="mat-error" *ngIf="enableError">{{routeRunErrorMsg}}</mat-hint>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="fill" class="col-4">
                <mat-label class="asterisk_input">Route Date</mat-label>
                <input matInput (dateInput)="OnDateChange($event.value)" placeholder="(Route Date)"
                    [matDatepicker]="routeDateId" [(ngModel)]="routeDate">
                <mat-datepicker-toggle matIconSuffix [for]="routeDateId"></mat-datepicker-toggle>
                <mat-datepicker #routeDateId></mat-datepicker>
                <mat-hint class="mat-error" *ngIf="enableError">{{routeDateErrorMsg}}</mat-hint>
            </mat-form-field>

        </div>
        <div>
            <mat-form-field appearance="fill" class="col-4">
                <mat-label class="asterisk_input">Truck Type</mat-label>
                <mat-select [compareWith]="compareObjects" [(ngModel)]="truckTypeChoosen">
                    <mat-option *ngFor="let truck of truckTypes" [value]="truck">
                        {{ truck.trailerType }} <!-- Display trailerType instead of object -->
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div class="col-4 text-right mb-3">
            <button class="submit-btn" [disabled]="!enableSubmit" mat-raised-button (click)="view()">
                View
            </button>
        </div>
    </div>


</div>